var ApolloWhcrAccordion = function(jQ) {

  function initWhcrAccordion() {
    jQ('.whc-accordion').each(function() {
      $panel = jQ(this).find('.panel').eq(0);
      $panel.find('.accordion-toggle').removeClass('collapsed');
      $panel.find('.panel-collapse').addClass('in');
    });
  }

  function init() {
    if (DEBUG) { console.info("ApolloWhcrAccordion.init()"); }

    initWhcrAccordion();
  }

  // public available functions
  return {
    init: init
  }

}(jQuery);
